import { toBarSerie } from "../../helper.ts";
import type { BarWidth, SeriesSettings } from "../../../../../../../../../api/types/svTypes.ts";

export function getBarWidthInPixels(serie: SeriesSettings | undefined): number {
  const barWidth = getBarWidth(serie);
  switch (barWidth) {
    case "Thin":
      return 10;
    case "Small":
      return 25;
    case "Medium":
      return 40;
    case "Large":
      return 55;
    default:
      return 25;
  }
}
function getBarWidth(serie: SeriesSettings | undefined): BarWidth {
  if (!serie) return "Medium";
  return toBarSerie(serie)?.barWidth || "Medium";
}
